import { render, staticRenderFns } from "./RankUserItem.vue?vue&type=template&id=2901c01e&scoped=true&"
import script from "./RankUserItem.vue?vue&type=script&lang=js&"
export * from "./RankUserItem.vue?vue&type=script&lang=js&"
import style0 from "./RankUserItem.vue?vue&type=style&index=0&id=2901c01e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2901c01e",
  null
  
)

export default component.exports